@if ((kontrakt$ | async); as kontrakt) {
  <div class="row"
    (mouseenter)="hoverRow(atgard.guid, true)"
    (mouseleave)="hoverRow(atgard.guid, false)">
    <div class="col-10">
      <div class="atgard-header-row">
        <div class="atgard-header-cell">
          <rask-atgard-badge [index]="index + 1"
          [avverkningsgrupp]="$safeNavigationMigration(atgard.avverkningsTyp?.grupp)"></rask-atgard-badge>
        </div>
        <div class="atgard-header-cell">{{atgard.beteckning}}</div>
        <rask-virkeskop-validation-icon-popover
          [entityGuid]="atgard.guid">
        </rask-virkeskop-validation-icon-popover>
        @if (kontrakt.isLeveransvirke) {
          <div class="atgard-header-cell">{{atgard.atgardsnamn}}</div>
        } @else {
          @if (!kontrakt.isGrot) {
            <div class="atgard-header-cell">{{atgard.atgardstyp}}</div>
          }
        }
        <div class="atgard-header-cell">
          <rask-atgard-header-icons></rask-atgard-header-icons>
        </div>
      </div>
      <div class="atgard-header-row">
        <div class="atgard-header-cell">{{volym | number: '1.0-0': 'sv'}} m3f</div>
        <div class="atgard-header-cell">{{atgard.nettoareal | number: '1.2-2': 'sv'}} ha</div>
        <div class="atgard-header-cell">{{atgard.status}}</div>
        <div class="atgard-header-cell">{{$safeNavigationMigration(atgard.arbetsorder?.produktionsStatus) | produktionsstatus}}</div>
      </div>
    </div>
    <div class="col-2 pt-2 pe-1">
      @if (atgard.arbetsorder?.id) {
        <div class="float-end">
          <rask-pillbox [text]="atgard.arbetsorder.beteckning"
            (click)="$event.stopPropagation()"
            [ngbPopover]="aoLinksPopup"
            placement="top-right"
            [autoClose]="'outside'">
            <rask-icon
            icon="far fa-ellipsis-v"></rask-icon>
          </rask-pillbox>
        </div>
      }
    </div>
  </div>
  <ng-template #aoLinksPopup>
    <div style="display: grid">
      <a [routerLink]="['/planera', atgard.arbetsorder.id]" class="mb-2" target="_blank">
        AO i RASK (ny flik)
        <i class="fa-regular fa-up-right-from-square"></i>
      </a>
      @if (isSchemalagd()) {
        <a href="{{prologLink()}}" target="_blank" class="mt-1">
          AO i Prolog (ny flik)
          <i class="fa-regular fa-up-right-from-square"></i>
        </a>
      }
    </div>
  </ng-template>
}